import { render } from "./TheAlertMessage.vue?vue&type=template&id=6ae536ac&scoped=true&ts=true&lang=html"
import script from "./TheAlertMessage.vue?vue&type=script&lang=ts"
export * from "./TheAlertMessage.vue?vue&type=script&lang=ts"

import "./TheAlertMessage.vue?vue&type=style&index=0&id=6ae536ac&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae536ac"]])

export default __exports__